"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = pureOrderBy;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

// the function orders by given order data any array-like object
function pureOrderBy(arr, givenKeys, orders) {
  if ('length' in arr && (0, _typeof2["default"])(arr) === 'object') {
    var defaultOrder = 'asc';
    var commonOrder;

    if (!(orders instanceof Array)) {
      commonOrder = orders || defaultOrder;
    }

    var length = arr.length;
    var result = Array(length);

    for (var i = 0; i < length; i++) {
      result[i] = arr[i];
    }

    if (!givenKeys) {
      return result;
    }

    var keys = givenKeys instanceof Array ? givenKeys : [givenKeys];
    return result.sort(function (a, b) {
      if (a && b) {
        for (var _i = 0; _i < keys.length; _i++) {
          var key = keys[_i];
          var order = (commonOrder || orders[_i]) !== 'desc' ? -1 : 1;

          if (a[key] > b[key]) {
            return -order;
          }

          if (a[key] < b[key]) {
            return order;
          }
        }
      }

      return 0;
    });
  }

  return [];
}
//# sourceMappingURL=_pureorderby.js.map